<template>
  <TarjetaDatos titulo="Vivienda Asegurada">
    <Campo2L :valor="poliza.direccion" etiqueta="Dirección" />
    <Campo2L :valor="poliza.poblacion" etiqueta="Población" />
    <Campo2L :valor="poliza.pais" etiqueta="País" />
    <Campo2L :valor="poliza.codPostal" etiqueta="Código Postal" />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    poliza: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
